import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { httpUpdateStepToAllocation } from '@/features/photoset/http/photoset.http'
import { MUTATION_KEYS } from '@/query-client'

export const useUpdateStepToAllocation = (
	options?: Omit<
		UseMutationOptions<unknown, AxiosError, number>,
		'mutationFn' | 'mutationKey'
	>
) =>
	useMutation({
		...options,
		mutationKey: [MUTATION_KEYS.UPDATE_STEP_ALLOCATION],
		mutationFn: httpUpdateStepToAllocation
	})
